var map = {
	"./GAGA-MILANO1647-copy.jpg": 1806,
	"./GAGA-MILANO1652-copy.jpg": 9900,
	"./GAGA-MILANO1757-copy.jpg": 1490,
	"./GAGA-MILANO1858-copy.jpg": 5004,
	"./GAGA-MILANO2208-copy.jpg": 8708,
	"./GAGA-MILANO2279-copy.jpg": 9096,
	"./GAGA-MILANO2372-copy.jpg": 6363
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8294;